<template>
  <div>
    <section class="Head">
      <div class="top-BG"></div>
      <div class="form-group row">
        <div class="col-md-12 text-white">
          <div class="title-line"></div>
          <h4><i class="fas fa-file-invoice-dollar"></i> Atualizações</h4>
        </div>
      </div>
      <section class="cards__container">
        <div class="head-card">
          <div class="head-card__left">
            <p class="head-card__left__title">Liquidações</p>
            <p v-if="!loading" class="head-card__left__info">{{dashboard.liquidacoes}}</p>
            <b-skeleton v-else width="60%"></b-skeleton>
          </div>
          <div class="head-card__right"><i class="fas fa-star"></i></div>
        </div>
        <div class="head-card">
          <div class="head-card__left">
            <p class="head-card__left__title">Amortizações</p>
            <p v-if="!loading" class="head-card__left__info">{{dashboard.amoritizacoes}}</p>
            <b-skeleton v-else width="60%"></b-skeleton>
          </div>
          <div class="head-card__right"><i class="fas fa-star-half-alt"></i></div>
        </div>
      </section>
    </section>
    <section class="body">
      <b-button @click="onSelectLiquidacao" :class="[selected === 'LIQUIDACAO' ? 'btn-third' : 'btn-outline-white', 'btn rounded mb-4']" >Liquidações</b-button>
      <b-button @click="onSelectAmortizacao" :class="[selected === 'ARMORTIZACAO' ? 'btn-third' : 'btn-outline-white', 'btn rounded mb-4']"  >Amortizações</b-button>
      <Tables
        ref="tableGrid"
        :columns="[
          'Nome',
          'Produto',
          'Valor Anterior',
          'Valor Atualizado',
          'Operação'
        ]"
        :showReload="true"
        :showTipFooter="false"
        v-on:Load="onLoad"
        v-on:Reload="onReload"
      >
        <tr v-for="(obj, index) in objList" v-bind:key="index">
          <TableColumn
            v-on:Edit="openCard(obj.card.id, obj.card.boardColumn.id)"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.pessoa.nome ? obj.pessoa.nome.toUpperCase() : ''"
          />
          <TableColumn
            v-on:Edit="openCard(obj.card.id, obj.card.boardColumn.id)"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.produto.nome ? obj.produto.nome : '-'"
            />
            <TableColumn
            v-on:Edit="openCard(obj.card.id, obj.card.boardColumn.id)"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="
            obj.valorAnterior ? obj.valorAnterior.toLocaleString('pt-Br', {style: 'currency', currency: 'BRL'}) : '-'
            "
            />
            <TableColumn
            v-on:Edit="openCard(obj.card.id, obj.card.boardColumn.id)"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="
            obj.valorAtual ? obj.valorAtual.toLocaleString('pt-Br', {style: 'currency', currency: 'BRL'}) : '-'
            "
            />
            <TableColumn
            v-on:Edit="openCard(obj.card.id, obj.card.boardColumn.id)"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.operacao ? obj.operacao.toUpperCase() : '-'"
            />
        </tr>
      </Tables>
    </section>
    <ModalCard ref="ModalCard" v-if="selectedCard" :boardColumns="[]" @hideModal="closeCard" :key="selectedCard" :cardId="selectedCard" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import CobrancaCardRepository from '@/shared/http/repositories/crm/cardCobranca.js'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'

const activities = {
  0: 'LIQUIDACAO',
  1: 'ARMORTIZACAO',
  2: 'INCLUSAO'
}

export default {
  name: 'Cobranca',
  mixins: [ActionsForm],
  data () {
    return {
      loading: true,
      dashboard: {
        amoritizacoes: null,
        liquidacoes: null
      },
      amoritizacoes: [],
      liquidacoes: [],
      inclusoes: [],
      selected: activities[0],
      selectedCard: null
    }
  },
  components: {
    ModalCard
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onReload () {
      switch (this.selected) {
        case activities[0]:
          this.onLoadLiquidacao()
          break
        case activities[1]:
          this.onLoadAmoritizacao()
          break
        case activities[2]:
          this.onLoadInclusao()
          break
      }
    },
    onLoadAll () {
      this.onLoadAmoritizacao()
      this.onLoadLiquidacao()
      this.onLoadInclusao()
      this.onLoadDashboard()
      this.$nextTick(() => {
        this.loading = false
      })
    },
    onLoadAmoritizacao () {
      CobrancaCardRepository.SearchUpdates(activities[1], this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((res) => {
          this.amoritizacoes = res.data.content
          if (this.selected === activities[1]) this.printGrid(res)
        })
        .catch(this.onException)
    },
    onLoadLiquidacao () {
      CobrancaCardRepository.SearchUpdates(activities[0], this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((res) => {
          this.liquidacoes = res.data.content
          if (this.selected === activities[0]) this.printGrid(res)
        })
        .catch(this.onException)
    },
    onLoadInclusao () {
      CobrancaCardRepository.SearchUpdates(activities[2], this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((res) => {
          this.inclusoes = res.data.content
          if (this.selected === activities[2]) this.printGrid(res)
        })
        .catch(this.onException)
    },
    async onLoadDashboard () {
      await CobrancaCardRepository.RefreshUpdatesDashboard(activities[1])
        .then((res) => { this.dashboard.amoritizacoes = res.data.totalElements })
        .catch(this.onException)
      await CobrancaCardRepository.RefreshUpdatesDashboard(activities[0])
        .then((res) => { this.dashboard.liquidacoes = res.data.totalElements })
        .catch(this.onException)
    },
    onSelectLiquidacao () {
      this.selected = activities[0]
      this.onReload()
    },
    onSelectAmortizacao () {
      this.selected = activities[1]
      this.onReload()
    },
    printGrid (res) {
      this.onResultGrid(res)
    },
    openCard (cardId) {
      this.selectedCard = cardId
    }
  }
}
</script>
<style lang="scss" scoped>

.cards__container {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  margin-top: 2rem;
  margin-bottom: 1.5rem;

  .head-card {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0.75rem 1rem;
    height: 5rem;
    width: 50%;

    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
    border-radius: 4px;

    &__left {
      &__title {
        font-size: 0.75rem;
        line-height: 100%;
        text-transform: uppercase;
        color: #8898aa;
        margin-bottom: 0.5rem;
      }

      &__info {
        font-weight: 600;
        font-size: 1rem;
        line-height: 100%;
        text-transform: uppercase;
        color: #4f5358;
      }

    }

    &:nth-child(1) .head-card__right {
      background: linear-gradient(90deg, #f53959 0%, #f55d39 100%);
    }

    &:nth-child(2) .head-card__right {
      background: linear-gradient(90deg, #fb6641 0%, #fbab40 100%);
    }

    &:nth-child(3) .head-card__right {
      background: linear-gradient(90deg, #2dce8b 0%, #2dceca 100%);
    }

    &:nth-child(4) .head-card__right {
      background: linear-gradient(180deg, #11c8ef 0%, #1275ef 100%);
    }

    &__right {
      width: 2rem;
      height: 2rem;
      aspect-ratio: 1;
      border-radius: 999px;

      display: flex;
      align-items: center;
      justify-content: center;

      i::before {
        font-size: 1rem;
        background: linear-gradient(
          180deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0) 137.5%
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
}

.title-line {
  width: 40px;
  height: 6px;
  margin: 22px 267px 9px 0px;
  border-radius: 3px;
  background-color: #fff;
}

.top-BG {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 55vh;

  background: linear-gradient(90deg, #2dce89 0%, #2dcecc 100%);
}
</style>



// WEBPACK FOOTER //
// src/views/private/cobranca/cobrancaUpdates.vue